import { FC } from 'react';
import { LandingProductSliderStoryblok } from 'storyblok-types';
import { getProductsByReferenceKeys } from 'commerce/scayle/product-management';
import {
  addAverageRatingToProducts,
  getAverageRatingForProducts,
} from 'commerce/services/reviews/utlls';
import { ProductTileSlider } from './ProductTileSlider/ProductTileSlider';

export const LandingProductSlider: FC<{
  blok: LandingProductSliderStoryblok;
}> = async ({ blok }) => {
  let sliderProductIds: string[] | undefined;

  const { productIds, title, titleColor, backgroundColor } = blok;

  if (productIds) {
    sliderProductIds = productIds[0]?.productIds
      ?.map(({ productId }) => productId)
      .filter((id): id is string => !!id);
  }

  const { response: products, error } = await getProductsByReferenceKeys(
    sliderProductIds || [],
  );
  const averageRating = await getAverageRatingForProducts(products ?? []);

  if (error) {
    console.error(error);
    return;
  }

  return (
    <>
      {products && (
        <ProductTileSlider
          products={addAverageRatingToProducts({
            products,
            rating: averageRating,
          })}
          title={title}
          titleColor={titleColor?.color}
          backgroundColor={backgroundColor?.color}
        />
      )}
    </>
  );
};
